class BulkAdd extends HTMLElement {
  static ASYNC_REQUEST_DELAY = 300;

  constructor() {
    super();
    this.queue = [];
    this.requestStarted = false;
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });
    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, BulkAdd.ASYNC_REQUEST_DELAY);
  }

  sendRequest(queue = this.queue) {
    this.requestStarted = true;
    const items = {};
    queue.forEach((queueItem) => {
      items[queueItem.id] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));

    const ids = Object.keys(items);
    this.updateMultipleQty(items, ids);
  }

  updateMultipleQty() {
    // This method should be overridden by child classes
  }

  validateQuantity(event) {
    let inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    const ruleMin = parseInt(event.target.dataset.ruleMin) || null;
    const ruleMax = parseInt(event.target.dataset.ruleMax) || null;
    const ruleStep = parseInt(event.target.dataset.ruleStep) || 1;

    // Snap to B2B catalog quantity rule when user enters a non-zero value below min,
    // not on a valid step, or above max. Zero is always allowed (means "skip variant").
    if (inputValue !== 0 && !isNaN(inputValue)) {
      if (ruleMin && inputValue < ruleMin) {
        inputValue = ruleMin;
      }
      if (ruleStep > 1 && ruleMin) {
        const offset = (inputValue - ruleMin) % ruleStep;
        if (offset !== 0) {
          inputValue = inputValue - offset + ruleStep;
        }
      }
      if (ruleMax && inputValue > ruleMax) {
        inputValue = ruleMax - ((ruleMax - (ruleMin || 0)) % ruleStep);
      }
      event.target.value = inputValue;
    }

    // Fallback to native min/max bounds if no rule attributes present
    if (!ruleMin && !ruleMax) {
      const nativeMin = parseInt(event.target.min);
      const nativeMax = event.target.max ? parseInt(event.target.max) : null;
      if (inputValue < nativeMin) {
        event.target.value = nativeMin;
        inputValue = nativeMin;
      } else if (nativeMax && inputValue > nativeMax) {
        event.target.value = nativeMax;
        inputValue = nativeMax;
      }
    }

    if (inputValue !== 0) {
      this.startQueue(index, inputValue);
    }
  }

  setRequestStarted(state) {
    this.requestStarted = state;
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  toggleLoading(loading) {
    // This method can be overridden by child classes if needed
    // Default implementation does nothing
  }
}

if (typeof customElements.get('bulk-add') === 'undefined') {
  customElements.define('bulk-add', BulkAdd);
}
